import { cn } from '@/utils/cn';
import {
  PAGE_SUBTITLE_STACKED_TYPE,
  PAGE_SUBTITLE_TYPE,
  PAGE_TITLE_TYPE,
  STATUS_BADGE_TYPE,
  TABLE_CELL_MUTED_TYPE,
  TABLE_CELL_TYPE,
  TABLE_HEADER_TYPE,
  TABLE_SECONDARY_TYPE,
  TYPE,
} from '@/lib/typography';

/** Shared staff page shell (Designmanual V2: 04 Layout, 03 Typografi, 08 Navigation). */

export const PAGE_TITLE = PAGE_TITLE_TYPE;

export const PAGE_SUBTITLE = PAGE_SUBTITLE_TYPE;

export const PAGE_SUBTITLE_STACKED = PAGE_SUBTITLE_STACKED_TYPE;

/** Desktop 24/32/48, mobile 16/16/32. No max width. */
export const PAGE_SHELL =
  'min-w-0 w-full px-s4 pb-s6 pt-s4 nav:px-s6 nav:pb-s7 nav:pt-s5';

/** Gap from the title row to tabs / toolbar / first body block. */
export const PAGE_BODY = 'mt-s5 min-w-0';

/** Title row only — no card, no extra padding. Min-height matches 40px controls. */
export const PAGE_HEADER = 'shrink-0';

export const PAGE_HEADER_ROW =
  'flex w-full min-w-0 flex-wrap items-start justify-between gap-s3 nav:flex-nowrap nav:items-center min-h-10';

/** Title and the gray subtitle share one text baseline (subtitle sits on the title bottom). */
export const PAGE_TITLE_INLINE = 'flex min-w-0 flex-1 items-baseline gap-s2';

export const PAGE_ACTIONS = 'flex min-h-10 flex-wrap items-center gap-s2';

export const PAGE_TOOLBAR = 'mt-s5 flex flex-wrap items-center gap-s2';

/** @deprecated PageLayout owns padding. Keep as a no-pad content stack. */
export const PAGE_CONTENT = 'min-w-0';

export const TOOLBAR_CONTROL = cn(
  TYPE.control,
  'clinio-control border border-ds-field bg-ds-card px-2.5 text-ds-muted shadow-none',
);

export const TOOLBAR_CLUSTER =
  'clinio-control-cluster border border-ds-field bg-ds-card';

export const TABLE_HEADER = TABLE_HEADER_TYPE;

export const TABLE_CELL = TABLE_CELL_TYPE;

export const TABLE_CELL_MUTED = TABLE_CELL_MUTED_TYPE;

export const TABLE_SECONDARY = TABLE_SECONDARY_TYPE;

export const STATUS_BADGE = STATUS_BADGE_TYPE;

/** @deprecated Use `<Button>` from `@/components/ui/Button`. Kept as an alias. */
export const PAGE_ACTION_BUTTON = 'clinio-btn clinio-btn--primary';

export function toolbarSegmentClass(active: boolean) {
  return cn(
    TYPE.control,
    'clinio-control-segment px-2.5 transition-colors',
    active
      ? 'bg-ds-card font-semibold text-ds-teal'
      : 'text-ds-muted hover:bg-ds-neutral-tint hover:text-ds-text',
  );
}
